import { handleActions } from 'redux-actions';
import { AddToGroupsPanelState } from './types';
import { addToGroupFolderSuccess, addToGroupFolderFail, addToGroupFolder } from './actions';
import { getGroupFolderKey } from './helpers';
import { reduxKey } from './constants';

const actionHandlers = handleActions<AddToGroupsPanelState, any>(
  {
    [addToGroupFolder.toString()]: (
      state,
      {
        payload: {
          deviation: { deviationId },
          groupFolderId,
        },
      }: ReturnType<typeof addToGroupFolder>
    ) => ({
      ...state,
      [getGroupFolderKey(deviationId, groupFolderId)]: {
        loading: true,
        added: false,
        suggested: false,
      },
    }),
    [addToGroupFolderSuccess.toString()]: (
      state,
      {
        payload: { deviationId, groupFolderId, suggested },
      }: ReturnType<typeof addToGroupFolderSuccess>
    ) => ({
      ...state,
      [getGroupFolderKey(deviationId, groupFolderId)]: {
        loading: false,
        added: !suggested,
        suggested,
      },
    }),
    [addToGroupFolderFail.toString()]: (
      state,
      { payload: { deviationId, groupFolderId } }: ReturnType<typeof addToGroupFolderFail>
    ) => ({
      ...state,
      [getGroupFolderKey(deviationId, groupFolderId)]: {
        loading: false,
        added: false,
        suggested: false,
      },
    }),
  },
  {}
);

export default {
  [reduxKey as string]: actionHandlers,
};
